// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1TI2R","log":"ModalInventoryLogs_log__2FVEA","date":"ModalInventoryLogs_date__2E7im","userName":"ModalInventoryLogs_userName__1KrgX"};